<template>
    <transition name="modal">
        <div class="CmnModal CmnModal--be-contacted" v-if="showModal">
            <div class="CmnModal__overlay" @click="onClose"></div>
            <div class="CmnModal__wrapper">
                <div class="CmnModal__container">                                        
                    <div class="CmnModal__content">                        
                        <to-be-contacted :professional="professional" :illustration="false" :cta="false" id="to-be-contacted" @contact="close()">
                            <template v-slot:header>
                                Contactez-nous
                            </template>    
                            <template v-slot:body>
                                <p>Pour mettre en place votre contrat ou avoir plus d’informations,<br>
                                merci de contacter l'équipe Cherchemonnid au 02.31.65.17.41.</p>
                            </template>
                        </to-be-contacted>
                    </div>
                </div>
            </div>
        </div>
    </transition>
</template>

<script>
import CmnModal from './CmnModal.vue';
import ToBeContacted from '../../containers/Subscriptions/ToBeContacted.vue'

export default {
    extends: CmnModal,
    name: 'cmn-modal-to-be-contacted',    
    components: {
        ToBeContacted
    },
    data() {
        return {
            professional : window.company
        }
    }
}
</script>

<style lang="sass" scoped>
    @import "./CmnModal"  

    #to-be-contacted 
        padding: 10px, 20% !important
</style>



// WEBPACK FOOTER //
// application/assets/js/professional/components/CmnModal/CmnModalToBeContacted.vue